// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  sectionTitle: {
    marginTop: theme.spacing(1),
    color: '#979797',
    fontSize: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  block: {
    marginBottom: theme.spacing(2),
  },
  blockTitle: {
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
  },
  rateLine: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    alignItems: 'baseline',
  },
  applies: {
    fontWeight: 600,
  },
  muted: {
    color: theme.palette.text.secondary,
  },
  sourceText: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  editorRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
  pricePerCreditProgress: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  caption: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
  },
});

export default styles;
